"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.make = void 0;
const tslib_1 = require("tslib");
const overlay_component_cjs_1 = require("./overlay.component.cjs");
const overlay_controller_cjs_1 = require("./overlay.controller.cjs");
const make = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    if (customElements.get('bud-error'))
        return;
    customElements.define('bud-error', overlay_component_cjs_1.Component);
    return new overlay_controller_cjs_1.Controller();
});
exports.make = make;
//# sourceMappingURL=index.cjs.map